
import React from 'react';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: "ri-phone-line",
      title: "Phone",
      details: "+1 (555) 123-4567",
      description: "Mon-Fri, 9AM-6PM EST"
    },
    {
      icon: "ri-mail-line",
      title: "Email",
      details: "hello@stupiddeep.com",
      description: "We respond within 24 hours"
    },
    {
      icon: "ri-map-pin-line",
      title: "Office",
      details: "123 Business District, New York, NY 10001",
      description: "By appointment only"
    }
  ];

  const team = [
    {
      name: "Dickie Paterson",
      role: "Founder & CEO",
      image: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/9b531a023a07da857c413e8d71a39bc2.jpeg",
      expertise: "E-commerce Growth & Strategy"
    },
    {
      name: "Jessica Hanson",
      role: "Logistics Director",
      image: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/e080806733a557c6570ec29b85769db5.jpeg",
      expertise: "International Shipping & Compliance"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Contact Methods */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Get in Touch
          </h2>
          
          <div className="space-y-6">
            {contactMethods.map((method, index) => (
              <div key={index} className="flex items-start p-6 bg-white rounded-lg shadow-sm">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${method.icon} text-xl text-indigo-600`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">{method.title}</h3>
                  <p className="text-gray-900 mb-1">{method.details}</p>
                  <p className="text-sm text-gray-600">{method.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Team */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            Meet Your Strategy Team
          </h3>
          
          <div className="space-y-4">
            {team.map((member, index) => (
              <div key={index} className="flex items-center p-4 bg-white rounded-lg shadow-sm">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{member.name}</h4>
                  <p className="text-indigo-600 text-sm font-medium">{member.role}</p>
                  <p className="text-gray-600 text-sm">{member.expertise}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Quick Stats */}
        <div className="bg-white rounded-lg p-8 shadow-sm">
          <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">
            Why Choose Us?
          </h3>
          
          <div className="grid grid-cols-2 gap-6 text-center">
            <div>
              <div className="text-2xl font-bold text-indigo-600 mb-1">500+</div>
              <div className="text-sm text-gray-600">Businesses Helped</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-indigo-600 mb-1">25+</div>
              <div className="text-sm text-gray-600">States Covered</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-indigo-600 mb-1">400%</div>
              <div className="text-sm text-gray-600">Avg. Growth</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-indigo-600 mb-1">98%</div>
              <div className="text-sm text-gray-600">Success Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
